import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  buttons: {
    width: 40,
    display: 'block'
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  column: {
    position: 'relative',
    width: 300,
    border: theme.card.border,
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),

    '& label': {
      display: 'block'
    }
  },
  header: {
    backgroundColor: theme.backgroundColor,
    height: 35,
    padding: theme.spacing(1)
  },
  body: {
    padding: theme.spacing(1)
  },
  label: {
    display: 'block'
  },
  applyButton: {
    //marginTop: theme.spacing(1.5)
    '& button': {
      marginRight: `${theme.spacing(2)}px !important`
    }
  },
  addButton: {
    minWidth: 0,
    width: 40,
    height: 40,
    padding: theme.spacing(1.5)
  },
  clearButton: {
    minWidth: 0,
    width: 40,
    height: 40,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5)
  },
  trash: {
    position: 'absolute',
    cursor: 'pointer',
    right: 8,
    top: 5
  },
  filterOptions: {
    marginBottom: theme.spacing(2)
  },
  logicOptions: {
    marginTop: theme.spacing(2),
    '& label': {
      display: 'block'
    }
  }
}))

export {
  useStyles
}